
import {
  Mixins,
  Component,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Pagination,
} from 'element-ui';

import {
  tSearch,
} from '@/components/Search/index';
import {
  IBTNCONF,
} from '@/types/base.d';
import api from '@/api/exam';
import tableMixin from './tableMixin';
import addOrModify from './components/addOrModify.vue';
@Component({
  components: {
    Dialog,
    Button,
    Pagination,
    tSearch,
    addOrModify,
  },
})

export default class examManage extends Mixins(tableMixin) {
  private isNeedAddOrModify = false;

  private actionBtns: Array < IBTNCONF > = [{
    title: '新增',
    name: '/exam/manage:add',
    icon: 'plus',
    callback: this.handleAddQuestion,
    log: {
      name: '题库 - 新增',
      component: '/exam/manage:add',
    },
  }];

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getPageTest();
  }

  private title = '';

  handleAddQuestion() {
    this.showOrCloseAdd();
    this.isEdit = false;
    this.title = '添加考试';
  }

  showOrCloseAdd() {
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  closeAddAndRefresh() {
    this.showOrCloseAdd();
    this.getPageTest();
  }

  mounted() {
    // 分页查询考试
    this.getPageTest();
  }

  // 点击修改跳转的添加页面
    private isEdit: Boolean = false;

    private examDes: String = '';

    private examName: String = '';

    private examTime: Number = 0;

    private examStartTime: string = '';

    private examEndTime: string = '';

    private testIds: string = '';

    private testType: string = '';

    private testTargetUser: string = '';

    private testPaperId: string = '';

    handleEdit(row: any) {
      this.testIds = row.id;
      this.isNeedAddOrModify = true;
      this.isEdit = true;
      this.examDes = row.description;
      this.examName = row.name;
      this.examTime = row.totalTime;
      this.title = '修改考试';
      this.testType = row.type;
      this.testTargetUser = row.targetUserType;
      this.examStartTime = row.beginTime;
      this.examEndTime = row.endTime;
      this.testPaperId = row.paperId;
    }
}
